import React, { useContext } from 'react';
import TitleBar from '../../comonents/TitleBar';
import BtnShow from '../../comonents/Buttons';
import './index.css'

import { useNavigate } from 'react-router-dom';
import ArrowDownRight from '../../comonents/Icons/Arrow-down-right';
import ArrowUpRight from '../../comonents/Icons/Arrow-up-right';
// import { useNavigate } from 'react-router-dom';
// import Cookies from 'js-cookie'
import { Context } from '../../context/Context'
// import { EXPRESS_SERVER_URL, COOKIES_EXPIRES_TIME } from "../../config";
// import axios from '../../axios'
import copy from 'copy-to-clipboard';
import Cookies from 'js-cookie'

export default function Game2CalculationDone() {
    const navigate = useNavigate();
    function toHelp() {
        navigate('/game2help')
    }
    return (
        <div>
            <TitleBar backLastPage="" lastPageName="" />

            <div style={{ paddingLeft: '1rem', paddingRight: '1rem', paddingTop: '1rem' }}>
                <div className='text-center'>
                    <b> <p className='h3' style={{ color: '#801E9E', paddingTop: '1rem', fontSize: '30px', paddingBottom: '1rem', fontWeight: 'bold' }}>Calculation of Hash 12 </p></b>
                </div>
                <div>
                    Detail of the Previous Hash Values<br /><br />
                    Hash 1:<br /><br />
                    Hash2:<br /><br />
                </div>
                <br />
                <br />
                <div className='CalculationInput_div'>
                    <div>
                        Hash 34 Value<br />
                        <input type="number" className='Calculation_hash_input'></input>
                    </div>
                    <br />
                    <div>
                        Nonce<br />
                        <input type="number" className='Calculation_hash_input'></input>
                    </div>
                </div>
                <div className='d-flex justify-content-end' style={{ paddingTop: '1rem' }} >
                    <input type='button' className=' calculation_help fw-bold' value={"Help ?"} onClick={e => toHelp()} />
                </div>
            </div>
            <div style={{ paddingTop: '2rem' }}>
                <div className='Btns_CD_Save'>
                    <input type="button" className='Btn_CD_Save' value='Save'></input>
                </div>
                <div className='Btns_CD_Back'>
                    <input type="button" className='Btn_CD_Back' value='Back' onClick={e => navigate(-1)} />
                </div>
            </div>
        </div>
    )
}